import { useIsFetching, useIsMutating } from '@tanstack/react-query';

import BILLING_STRIPE_PAYMENT_MUTATION_KEY from './mutationKey';
import { BILLING_STRIPE_PAYMENT_DETAILS_QUERY_KEY } from './useFetchDetails';

/** Whether any step of taking a Stripe payment is in flight. */
const useIsBillingStripePaymentInFlight = () => {
	const mutating = useIsMutating({
		mutationKey: [BILLING_STRIPE_PAYMENT_MUTATION_KEY],
	});
	const fetchingDetails = useIsFetching({
		queryKey: [BILLING_STRIPE_PAYMENT_DETAILS_QUERY_KEY],
	});

	return mutating + fetchingDetails > 0;
};

export default useIsBillingStripePaymentInFlight;
